<template>
  <p class="text-muted-foreground text-xl font-normal  leading-7">
   <slot />
  </p>
</template>